import axios from "../config/axios";
import { useQuery } from "react-query";

// [8]
const getPsnordersByBookId = async (book_id:string) => {
  const res = await axios.GENERAL.get("/psnorders/by_book_id/"+book_id)
  if (res.status === 200) {
    console.log("getPsnordersByBookId", res);
    return res.data
  }
}
// [8-1]
// INPUT
// text_list: [ ‘word1’, ‘word2’, ….]
// operation_mode: AND or OR
const getPsnordersSearch = async (query:any) => {
  const res = await axios.GENERAL.post(
    "/psnorders/search_by_text", query);
  if (res.status === 200) {
    console.log("getPsnordersSearch", res);
    return res.data;
  }
}
// [8-2]
const getPsnordersByPersonId = async (person_id: number) => {
    const res = await axios.GENERAL.get("/psnorders/by_person_id/"+person_id)
    if (res.status === 200) {
        console.log("getPsnordersByPersonId", res)
        return res.data
    }
}

// relation
// [16]
// INPUT
// school_id \ if null select All
// person_id\ if null select All
// region_id\ if null select All
const getPsnordersBySPR = async (query: any) => {
  const res = await axios.GENERAL.post("/psnorders/relation", query)
  if (res.status === 200) {
    // console.log("getPsnordersBySPR", res);
    return res.data
  }
}

// [16-1]
const getPsnordersBySchoolId = async (school_id: string) => {
  const res = await axios.GENERAL.get("/psnorders/related_by_school/" + school_id)
  if (res.status === 200) {
    console.log("getPsnordersBySchoolId", res);
    return res.data
  }
}
// [16-2]
const getPsnordersByPersonIds = async (person_id: string) => {
  const res = await axios.GENERAL.get("/psnorders/related_by_person/" + person_id)
  if (res.status === 200) {
    console.log("getPsnordersByPersonId", res)
    return res.data
  }
}
// [16-3]
const getPsnordersByRegionId = async (region_id: string) => {
  const res = await axios.GENERAL.get("/psnorders/related_by_region/" + region_id)
  if (res.status === 200) {
    console.log("getPsnordersByRegionId", res);
    return res.data
  }
}

export default {
  getPsnordersByBookId,
  getPsnordersSearch,
  getPsnordersBySPR,
  getPsnordersBySchoolId,
  getPsnordersByPersonId,
  getPsnordersByRegionId,
  getPsnordersByPersonIds
};